export function toDateDiff(pTime) {
  const timeNow = parseInt(new Date().getTime() / 1000)
  const pTime_new = parseInt(pTime / 1000)
  const d = timeNow - pTime_new
  // const d_days = parseInt(d / 86400)
  // const d_hours = parseInt(d / 3600)
  // const d_minutes = parseInt(d / 60)
  const date = new Date(parseInt(pTime))
  const Y = date.getFullYear()
  const M = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
  const D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
  const h = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
  const m = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
  // const s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()

  const dateNow = new Date()
  const daysTime = parseInt(
    new Date(new Date(parseInt(pTime)).setHours(0, 0, 0, 0)).getTime() / 1000
  )
  // return daysNow
  const hoursTime = parseInt(
    new Date(new Date(parseInt(pTime)).setMinutes(0, 0, 0)).getTime() / 1000
  )

  const minutesTime = parseInt(
    new Date(new Date(parseInt(pTime)).setSeconds(0, 0)).getTime() / 1000
  )

  const d_day = parseInt((timeNow - daysTime) / 86400)
  const d_hours = parseInt((timeNow - hoursTime) / 3600)
  const d_minutes = parseInt((timeNow - minutesTime) / 60)
  const Y_Now = dateNow.getFullYear()
  const M_Now =
    dateNow.getMonth() + 1 < 10 ? '0' + (dateNow.getMonth() + 1) : dateNow.getMonth() + 1
  const D_Now = dateNow.getDate() < 10 ? '0' + dateNow.getDate() : dateNow.getDate()
  const h_Now = dateNow.getHours() < 10 ? '0' + dateNow.getHours() : dateNow.getHours()
  // const m_Now = (dateNow.getMinutes() < 10 ? '0' + date.getMinutes() : dateNow.getMinutes())
  // const s_Now = dateNow.getSeconds() < 10 ? '0' + date.getSeconds() : dateNow.getSeconds()
  if (Y_Now - Y >= 1) {
    return '' + Y + '年' + M + '月' + D + '日'
  } else if (d_day > 15) {
    return '' + M + '月' + D + '日'
  } else if (d_day >= 2) {
    return '' + d_day + '天前'
  } else if (d_day == 1) {
    return '昨天' + h + ':' + m
  } else if (d_hours >= 1) {
    return '' + h + ':' + m
  } else if (d_minutes >= 1) {
    return '' + d_minutes + '分钟前'
  } else {
    return '刚刚'
  }
}
export function toPrice(num) {
  var num = parseInt(num)
  if (typeof num !== 'number' || isNaN(num)) return null
  return (num / 100).toFixed(2)
}
export function toDate(date) {
  date = new Date(parseInt(date))
  const Y = date.getFullYear() + '-'
  const M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
  const D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '
  const h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
  const m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':'
  const s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
  return Y + M + D + h + m + s
}

export function toDate_YMD(date) {
  if (date > 0) {
    date = new Date(parseInt(date))
    const Y = date.getFullYear() + '-'
    const M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
    const D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
    return Y + M + D
  } else {
    return ''
  }
}

export function toEtime(eTime) {
  const timeNow = parseInt(new Date().getTime() / 1000)
  const eTime_new = parseInt(eTime / 1000)
  const d = eTime_new - timeNow
  const d_hours = parseInt(d / 3600)
  const d_minutes = parseInt(d / 60)
  if (d_hours > 0) {
    return d_hours + '小时'
  } else if (d_hours <= 0 && d_minutes > 0) {
    return d_minutes + '分钟'
  }
}

//持续时间
export function toTime(time) {
  const d_hours = parseInt(time / 60)
  const d_minutes = parseInt(time)
  if (d_hours > 0) {
    return d_hours + '小时'
  } else if (d_hours <= 0 && d_minutes > 0) {
    return d_minutes + '分钟'
  }
}

export function Ftime(timespan) {
  var dateTime = new Date(timespan)
  var year = dateTime.getFullYear()
  var month = dateTime.getMonth() + 1
  var day = dateTime.getDate()
  var hour = dateTime.getHours() < 10 ? '0' + dateTime.getHours() : dateTime.getHours()
  var minute = dateTime.getMinutes() < 10 ? '0' + dateTime.getMinutes() : dateTime.getMinutes()
  //当前时间
  var now = Date.parse(new Date()) //typescript转换写法
  var milliseconds = 0
  var timeSpanStr
  //计算时间差
  milliseconds = now / 1000 - timespan / 1000

  //一分钟以内
  if (milliseconds <= 60) {
    timeSpanStr = '刚刚'
  }
  //大于一分钟小于一小时
  else if (60 < milliseconds && milliseconds <= 60 * 60) {
    timeSpanStr = Math.ceil(milliseconds / 60) + '分钟前'
  }
  //大于一小时小于等于一天
  else if (60 * 60 < milliseconds && milliseconds <= 60 * 60 * 24) {
    timeSpanStr = Math.ceil(milliseconds / (60 * 60)) + '小时前'
  }
  //大于一天小于等于15天
  else if (60 * 60 * 24 < milliseconds && milliseconds <= 60 * 60 * 24 * 30) {
    timeSpanStr = Math.ceil(milliseconds / (60 * 60 * 24)) + '天前'
  }
  //大于一个月小于一年
  else if (60 * 60 * 24 * 30 < milliseconds && milliseconds <= 60 * 60 * 24 * 30 * 12) {
    timeSpanStr = Math.ceil(milliseconds / (60 * 60 * 24 * 30)) + '个月前'
  }
  //超过一年显示
  else {
    timeSpanStr = year + '年' + month + '月' + day + '日 ' + hour + ':' + minute
  }
  return timeSpanStr
}

export function FFtime(timespan) {
  var dateTime = new Date(timespan)
  var year = dateTime.getFullYear()
  var month = dateTime.getMonth() + 1
  var day = dateTime.getDate()
  var hour = dateTime.getHours() < 10 ? '0' + dateTime.getHours() : dateTime.getHours()
  var minute = dateTime.getMinutes() < 10 ? '0' + dateTime.getMinutes() : dateTime.getMinutes()
  //当前时间
  var now = Date.parse(new Date()) //typescript转换写法
  var milliseconds = 0
  var timeSpanStr
  //计算时间差
  milliseconds = now / 1000 - timespan / 1000

  //一分钟以内
  if (milliseconds <= 60) {
    timeSpanStr = '刚刚'
  }
  //大于一分钟小于一小时
  else if (60 < milliseconds && milliseconds <= 60 * 60) {
    timeSpanStr = Math.ceil(milliseconds / 60) + '分钟前'
  }
  //大于一小时小于等于一天
  else if (60 * 60 < milliseconds && milliseconds <= 60 * 60 * 24) {
    timeSpanStr = hour + ':' + minute
  }
  //大于一天小于等于15天
  else if (60 * 60 * 24 < milliseconds && milliseconds <= 60 * 60 * 24 * 15) {
    timeSpanStr = Math.ceil(milliseconds / (60 * 60 * 24)) + '天前'
  }
  //大于一个月小于一年
  else if (60 * 60 * 24 * 15 < milliseconds && milliseconds <= 60 * 60 * 24 * 30 * 12) {
    timeSpanStr = month + '月' + day + '日 '
  }
  //超过一年显示
  else {
    timeSpanStr = year + '年' + month + '月' + day + '日 '
  }
  return timeSpanStr
}
export function cutstr(str, len) {
  if (str.length == 0) {
    return str
  } else if (str.length <= len) {
    return str
  } else {
    return str.substring(0, len) + '...'
  }
}
export function limitstr(str, len) {
  return str.substring(0, len)
}
// export function name_filter(username) {
//   const mobileRE = /^(((13[0-9]{1})|(14[57]{1})|(15[0-9]{1})|(17[0-9]{1})|(18[0-9]{1}))+\d{8})$/
//   if (mobileRE.test(username)) {
//     return username.replace(/(\d{3})\d{6}(\d{2})/, '$1******$2');
//   } else {
//     return username
//   }
// }
export function name_filter(username) {
  return username.realSubstring(5)
}
String.prototype.realSubstring = function(n) {
  var str = this || ''
  if (this.realLength() <= n) {
    return this
  }
  var m = Math.ceil(n / 2)
  for (var i = m; i < this.length; i++) {
    if (this.substr(0, i).realLength() >= n) {
      return this.substr(0, i) + '**'
    }
  }
  return this
}
String.prototype.realLength = function() {
  return this.replace(/[^\x00-\xff]/g, '**').length // [^\x00-\xff] - 匹配非双字节的字符
}

export function phone_str(phone) {
  return phone.replace(/\d{7}(\d{4})/, '*******$1')
}
export function Fen2Yuan(num) {
  var num = parseInt(num)
  if (typeof num !== 'number' || isNaN(num)) return null
  return (num / 100).toFixed(2)
}
export function largenum(num) {
  if (num >= 10000) {
    largenum = (num / 10000).toFixed(1) + '万'
  } else if (num >= 100000) {
    largenum = parseInt(num / 10000) + '万'
  } else {
    largenum = num
  }
  return largenum
}

export function toDecimal2(x) {
  var f = parseFloat(x)
  if (isNaN(f)) {
    return false
  }
  var f = Math.round(x * 100) / 100
  var s = f.toString()
  var rs = s.indexOf('.')
  if (rs < 0) {
    rs = s.length
    s += '.'
  }
  while (s.length <= rs + 2) {
    s += '0'
  }
  return s
}



// WEBPACK FOOTER //
// ./src/utils/filters.js